<!--suppress ALL -->

<template>
	<tr>
		<td class="text-xs-center">
			{{type.name }}
		</td>
		<td class="text-xs-center">
			{{type.open_question }}
		</td>
		<td class="text-xs-center">
			{{type.close_question }}
		</td>
		<td class="text-xs-center">
			{{type.yes_no_question }}
		</td>
		<td class="text-xs-center">
			{{type.json_path }}
		</td>
		<td>
			<edit-btn @click="onEdit" class="mx-2 my-1"/>
			<remove-btn @remove="doRemove" class="mx-2 my-1"/>
		</td>

	</tr>
</template>

<script>

	import {types} from "src/store/modules/Type.module";
	import RemoveBtn from "src/scaffoldings/RemoveBtn";
	import EditBtn from "src/scaffoldings/EditBtn";
	import RowMixin from "src/mixins/RowMixin";

	export default {
		name: "type-row",
		props: {
			type:{required:true}
		},
		components: {EditBtn, RemoveBtn},
		mixins: [new RowMixin(types, "type")],
		data() {
			return {};
		},
		computed: {},
		methods: {
			doRemove() {
				this.$store.dispatch(types.REMOVE, this.type).then(() => {
				});
			},
			onEdit() {
				this.$emit("edit", this.type);
			}
		}
	};
</script>

<style>


</style>
